<script>
import {alteraPixPagador} from '../../../../../domain/pre-retirada/services'
import PopupViewerAlert from '../../../../_default/components/popup-viewer/PopupViewerAlert'

export default {
  name: 'BtnAlteraPixPagador',
  components: {PopupViewerAlert},
  props: {
    preRetiradaId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      pixPagador: null,
      show: false
    }
  },
  computed: {
    isValid () {
      return (this.pixPagador || '').trim()
    }
  },
  methods: {
    setPixPagador () {
      if (!confirm(`ATENÇÃO: Confirmar alteração do pix pagador para "${this.pixPagador}"?`)) {
        this.show = false
        this.pixPagador = null
        return
      }
      this.$loaderOverlay.open().message('Alterando...')
      alteraPixPagador(this.preRetiradaId, this.pixPagador)
        .then(response => {
          this.show = false
          this.pixPagador = null
          this.$emit('pixAlterado', response.data.chavePixPagador)
        })
        .catch(error => {
          alert('Houve um erro ao alterar')
          console.log(error.data)
        })
      .finally(() => {
        this.$loaderOverlay.hide()
      })
    },
    toggleShow () {
      this.show = !this.show
    },
    cancelar () {
      this.pixPagador = null
      this.show = false
    }
  }
}
</script>

<template>
<div>
  <div class="m-t-sm m-b-sm">
    <a class="btn btn-default font-bold btn-dark" @click="toggleShow">{{show ? 'Cancelar' : 'Alterar pix pagador'}}</a>
  </div>
  <popup-viewer-alert v-if="show" title="Alteração manual de pix pagador">
    <div class="form-group m-t-sm">
      <input v-model="pixPagador" class="form-control" required />
    </div>
    <div style="display: flex; justify-content: end; align-items: center">
      <button class="btn btn-sm btn-default m-l" @click="cancelar">Cancelar</button>
      <button class="btn btn-sm btn-info m-l" @click="setPixPagador" :disabled="!isValid">Confirmar</button>
    </div>
  </popup-viewer-alert>
</div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// BtnAlteraPixPagador.vue?79e04aff